export default "__VITE_ASSET__B5YsZOW3__"